export default __webpack_public_path__ + "static/media/bike_placeholder.0301e591.png";